<template>
  <b-card>
    <div class="mb-3">
      <div class="text-black text-2xl font-semibold">
        Tambah Peserta
      </div>
    </div>
    <b-row>
      <b-col>
        <b-form-group
          id="input-group-1"
          label-for="input-1"
          class="mt-2"
        >
          <div

            class="w-[100%] md:w-[40%]"
          >
            <b-form-group
              id="fieldset-1"
              label="Email"
              label-class="font-medium text-7 text-black"
              label-for="email"
            >

              <v-select
                id="email"
                v-model="email"
                taggable
                :options="state.optionEmail"
                label="email"
                placeholder="Pilih email peserta"
                @input="handleInputEmail"
                @search="debounceSearchEmail"
              />
            </b-form-group>

            <div class="mb-1">

              <b-form-group
                id="fieldset-1"
                label="Nama Lengkap"
                label-class="font-medium text-7 text-black"
                label-for="name_participant"
              >

                <b-form-input
                  id="name_participant"
                  v-model="state.form.name"
                  type="text"
                  placeholder="Masukan nama peserta"
                  required
                />
              </b-form-group>
            </div>
            <div class="mb-1">
              <b-form-group
                id="fieldset-1"
                label="No Hp"
                label-class="font-medium text-7 text-black"
                label-for="handphone"
              >

                <b-input-group prepend="+62">
                  <b-form-input
                    id="handphone"
                    v-model="state.form.handphone"
                    type="number"
                    placeholder="8xxxxxxxxxxx"
                    required
                    @keypress="isNumber($event)"
                    @input="debounceWhatsApp"
                  />

                </b-input-group>
              </b-form-group>
            </div>
            <div class="mb-1">
              <b-form-group
                id="fieldset-1"
                label="Kota"
                label-class="font-medium text-7 text-black"
                label-for="city"
              >

                <v-select
                  id="city"
                  v-model="state.form.city"
                  :options="state.optionCity"
                  label="city"
                  placeholder="Pilih kota asal peserta"
                  @search="debounceSearchCity"
                >
                  <template #no-options>
                    {{ "" }}
                  </template>
                </v-select>
              </b-form-group>
            </div>
            <div>
              <div class="font-semibold text-black">
                Produk Yang Terdaftar
              </div>
              <div
                class="d-flex gap-2 container-img"
              >
                <div
                  class="w-[3rem] h-[3rem] "
                  :class="state.form.product.komship ? 'bg-icon' : 'opacity'"
                >
                  <img
                    src="https://storage.googleapis.com/komerce/assets/logo/Product-Komship.svg"
                    alt="logo-komship"
                    class="mb-[-6px]"
                  >
                </div>
                <div
                  class="w-[3rem] h-[3rem]"
                  :class="state.form.product.komtim? 'bg-icon' : 'opacity' "
                >
                  <img
                    src="https://storage.googleapis.com/komerce/assets/logo/logo_komtim.svg"
                    alt="logo-komtim"
                  >
                </div>
                <div
                  class="w-[3rem] h-[3rem] "
                  :class="state.form.product.kompack? 'bg-icon' : 'opacity'"
                >
                  <img
                    src="https://storage.googleapis.com/komerce/assets/svg/logo_kompack.svg"
                    alt="logo-kompack"
                  >
                </div>
                <div
                  class="w-[3rem] h-[3rem]"
                  :class="state.form.product.komcard? 'bg-icon' : 'opacity'"
                >

                  <img
                    src="https://storage.googleapis.com/komerce/assets/logo/Product-Komcards.svg"
                    alt="logo-komcard"
                  >
                </div>

                <div
                  class="w-[3rem] h-[3rem]"
                  :class="state.form.product.boostr? 'bg-icon' : 'opacity'"
                >
                  <img
                    src="https://storage.googleapis.com/komerce/assets/LP-Komerce/komplace.svg"
                    alt="logo-boostr"
                    class="h-6"
                  >
                </div>
                <div
                  class="w-[3rem] h-[3rem] "
                  :class="state.form.product.pendamping_umkm? 'bg-icon' : 'opacity'"
                >
                  <img
                    src="https://storage.googleapis.com/komerce/assets/logo/Product-Pendamping%20UMKM.svg"
                    alt="logo-p-umkm"
                  >
                </div>
              </div>
              <p
                class="mt-1"
              >
                Terdaftar di {{ Object.values(state.form.product).filter(value => value === true).length, }} Product
              </p>
            </div>
          </div>
          <div
            class="d-flex justify-end "
            style="gap: 1rem;"
          >
            <b-button
              variant="outline-primary"
              @click="handleBack"
            >
              Kembali
            </b-button>
            <b-button
              v-b-modal.modal-add-event
              :disabled="!email || state.form.name.length <= 2 || !state.form.city || !state.form.whatsapp || !state.form.handphone.length"
              variant="primary"
              type="submit"
              @click="handleSubmit"
            >
              Simpan
            </b-button>
          </div>
        </b-form-group>
      </b-col>
    </b-row>
  </b-card>

</template>

<script>
import { reactive, onMounted, ref } from '@vue/composition-api'
import { newAxiosIns, komshipAxiosIns } from '@/libs/axios'
import { useRouter } from '@/@core/utils/utils'
import router from '@/router'
import vSelect from 'vue-select'
import { isNumber } from '@/libs/helpers'
import { toastError, toastSuccess } from '../../config'

export default {
  components: {
    vSelect,
  },
  setup() {
    const route = useRouter()
    const state = reactive({
      loading: true,
      data: {},
      form: {
        email: '',
        name: '',
        handphone: '',
        city: '',
        whatsapp: true,
        product: {
          kompack: false,
          komship: false,
          komtim: false,
          komcard: false,
          boostr: false,
          pendamping_umkm: false,
        },
      },
      optionEmail: [],
      optionCity: [],
      optionsEmail: [],
      debounceEmail: null,
      debounceCity: null,
      debounceWA: null,
    })

    const email = ref()

    function checkWA(number) {
      const url = '/v1/check-wa'
      komshipAxiosIns
        .post(url, { phone_no: number })
        .then(res => {
          const { data } = res.data
          if (data === 'valid') {
            state.form.whatsapp = true
          } else {
            state.form.whatsapp = false
          }
        })
        .catch(err => {
          state.form.whatsapp = false
          // eslint-disable-next-line no-console
          console.log(err)
        })
    }

    function debounceWhatsApp(number) {
      if (state.debounceWA) {
        clearTimeout(state.debounceWA)
      }
      state.debounceWA = setTimeout(() => {
        checkWA(number)
      }, 1000)
    }
    function handleInputEmail(value) {
      const data = state.optionsEmail.filter(item => item.email === value)
      if (data.length) {
        let noHp = data[0].no_hp
        if (noHp.charAt(0) === '0') {
          noHp = noHp.slice(1)
        }
        state.form.name = data[0].full_name
        state.form.handphone = noHp
        state.form.product.komcard = data[0].komcard
        state.form.product.boostr = data[0].komplace
        state.form.product.komship = data[0].komship
        state.form.product.komtim = data[0].komtim
        state.form.product.kompack = data[0].kompack
        state.form.product.pendamping_umkm = data[0].pendamping_umkm
        checkWA(noHp)
      }
    }

    function getEmail(values) {
      if (values.length < 3) {
        return
      }
      const url = '/komclass/api/v2/users/option/email'
      newAxiosIns
        .get(url, {
          params: { email: values },
        })
        .then(res => {
          const { data } = res.data
          state.optionsEmail = data
          state.optionEmail = data.map(item => item.email)
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.log(err)
        })
    }
    function debounceSearchEmail(search) {
      if (state.debounceEmail) {
        clearTimeout(state.debounceEmail)
      }
      state.debounceEmail = setTimeout(() => {
        getEmail(search)
      }, 1000)
    }

    async function searchCity(search) {
      if (search.length < 3) {
        return
      }
      const url = '/komclass/api/v1/event/option/city'
      await newAxiosIns
        .get(url, { params: { keyword: search } })
        .then(res => {
          const { data } = res.data
          state.optionCity = data.map(item => item.name)
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.log(err, 'error')
        })
    }

    function debounceSearchCity(search) {
      if (state.debounceCity) {
        clearTimeout(state.debounceCity)
      }
      state.debounceCity = setTimeout(() => {
        searchCity(search)
      }, 1000)
    }

    function handleSubmit() {
      state.data = {
        event_id: parseInt(route.route.value.query.idEvent, 10),
        id: 0,
        email: email.value,
        name: state.form.name,
        phone: parseInt(state.form.handphone, 10),
        whatsapp: true,
        city: state.form.city,
        product: {
          kompack: state.form.product.kompack,
          komship: state.form.product.komship,
          komtim: state.form.product.komtim,
          komcard: state.form.product.komcard,
          boostr: state.form.product.boostr,
          pendamping_umkm: state.form.product.pendamping_umkm,
        },
      }
      const url = '/komclass/api/v1/event/attendance/upsert'
      newAxiosIns.post(url, state.data)
        .then(res => {
          const { data } = res.data
          toastSuccess('Berhasil menambahkan peserta')
          router.back()
        })
        .catch(err => {
          toastError('Ada kesalahan saat menambah peserta')
          router.back()
        })
    }

    function handleBack() {
      router.back()
    }
    return {
      debounceSearchEmail,
      komshipAxiosIns,
      getEmail,
      checkWA,
      debounceSearchCity,
      searchCity,
      handleSubmit,
      handleBack,
      debounceWhatsApp,
      isNumber,
      handleInputEmail,
      state,
      email,
    }
  },

}
</script>

<style  scooped lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';
.container-img {
  gap: 3px;
}
.opacity {
  opacity: 0.2;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-items: center;
  padding: 2px;
}
.bg-icon {
  background-color: antiquewhite;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  justify-items: center;
  align-items: center;
  padding: 2px;
}
</style>
